import { cn } from "@/utils/helpers";

interface SpinningLogoProps {
  className?: string;
}

export const SpinningLogo = ({ className }: SpinningLogoProps) => (
  <div className={cn("logo-container", className)} aria-hidden="true">
    <div className="logo">
      <div className="logo-face logo-front" />
      <div className="logo-face logo-back" />
    </div>
  </div>
);
